<template>
  <main class="imaged-list resources__page-topic">
    <div class="resources__top-wrap">
      <RichRenderer v-if="page.paragraphRich" :richTextData="page.paragraphRich" />
    </div>
    <div class="resources__content-list">
      <div
        v-for="(item, n) in entries"
        :key="`${item.title}-${n}`"
        :ref="item.title"
        class="resources__content-item resources__content-item--with-img"
      >
        <a :href="item.payloadUrl" target="_blank" class="resources__content-link">
          <img v-if="item.img" :src="item.img" :alt="item.imgAlt" class="resources__content-img" />
        </a>
        <div class="resources__content-inner-wrap">
          <a
            :href="item.payloadUrl"
            class="resources__content-item-title text-link"
            target="_blank"
            v-html="item.title"
          />
          <p class="text-description" v-html="item.description" />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import arraySort from 'array-sort'
import { getCurrentInstance, nextTick, onMounted, ref } from 'vue'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

import { useErrorService } from '@/composables/useErrorService'
import { useNavigation } from '@/composables/useNavigation'
import { usePageMeta } from '@/composables/usePageMeta'
import { useTransformEntries } from '@/composables/useTransformEntries'
import { PAGETYPES } from '@/settings/constants'

export default {
  name: 'ImagedList',
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { fetchItems } = useContentfulComponent()
    const { setPageMeta } = usePageMeta()
    const errorService = useErrorService()
    const { transformEntries } = useTransformEntries()
    const { anchorToEntry } = useNavigation()
    const instance = getCurrentInstance()

    const entries = ref([])

    const initData = async (rawEntries) => {
      entries.value = rawEntries.filter((entry) => entry.payloadUrl)
      if (props.cPage.pageType === PAGETYPES.CATEGORY_RESOURCE_INVENTORY) {
        entries.value = arraySort(transformEntries(entries.value), 'title')
      } else {
        entries.value = transformEntries(entries.value)
      }
      await nextTick()
      anchorToEntry(entries.value, instance?.refs)
    }

    setPageMeta(props.cPage?.fields?.pageMeta)

    onMounted(async () => {
      const query = {
        skip: 0,
        limit: 1000,
        include: 1,
        order: '-fields.date,sys.createdAt',
        content_type: 'resource',
        'fields.resourceGroup.sys.id': props.cPage.sys.id,
      }
      const entries = await fetchItems(query)
      if (!entries) {
        const error = new Error('No contentful entry on Resource request')
        errorService.decorateError('CONTENTFUL', error, { errorLevel: 'network' })
        throw error
      } else {
        initData(entries)
      }
    })

    return {
      entries,
    }
  },
  computed: {
    page() {
      return this.cPage.fields
    },
  },
}
</script>
